// CPU fallback can mount many canvases. Keep exact worker RGBA8 sources under
// a small shared cap; previews and incomplete jobs are never admitted.
const MAX_SOURCE_BYTES = 16 * 1024 * 1024;
const entries = new Map();
let chargedBytes = 0;
let peakChargedBytes = 0;
let evictions = 0;

export function getCpuExactFrame(owner) {
  const frame = entries.get(owner);
  if (!frame) return null;
  entries.delete(owner);
  entries.set(owner, frame);
  return frame;
}

export function clearCpuExactFrame(owner) {
  const frame = entries.get(owner);
  if (!frame) return;
  entries.delete(owner);
  chargedBytes -= frame.pixels.byteLength;
}

export function setCpuExactFrame(owner, frame) {
  clearCpuExactFrame(owner);
  if (!frame || frame.pixels.byteLength > MAX_SOURCE_BYTES) return false;
  // NumberCamera.toShallowRanges() yields mutable arrays. A worker RGBA source
  // must keep the endpoint values used for its own completed grid.
  const ranges = frame.ranges ? Object.freeze({
    xRange: Object.freeze([...frame.ranges.xRange]),
    yRange: Object.freeze([...frame.ranges.yRange])
  }) : null;
  while (entries.size && chargedBytes + frame.pixels.byteLength > MAX_SOURCE_BYTES) {
    const oldest = entries.keys().next().value;
    clearCpuExactFrame(oldest);
    evictions++;
  }
  entries.set(owner, Object.freeze({ ...frame, ranges }));
  chargedBytes += frame.pixels.byteLength;
  peakChargedBytes = Math.max(peakChargedBytes, chargedBytes);
  return true;
}

export function cpuExactFrameCacheMetrics() {
  return { chargedBytes, frames: entries.size, maxBytes: MAX_SOURCE_BYTES,
    peakChargedBytes, evictions };
}
